import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const go = (path: string) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

interface PublicHeaderProps {
  title?: string;
}

const PublicHeader: React.FC<PublicHeaderProps> = ({ title }) => {
  const { user } = useAuth();
  const isAuthenticated = !!user;
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between py-3">
        <button onClick={() => go('/')} className="flex items-center gap-3" aria-label="Tumbulgum Fishing Club home">
          <img src="/tumbulgum-logo.png" alt="Tumbulgum Fishing Club" className="h-12 w-auto" />
          {title && <span className="text-gray-700 font-semibold hidden sm:inline">{title}</span>}
        </button>
        <button onClick={() => go('/dashboard')}
          aria-label={isAuthenticated ? 'Go to my account' : 'Log in'}
          className="bg-fishing-blue hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold shadow-sm transition-colors">
          {isAuthenticated ? 'My Account' : 'Login'}
        </button>
      </div>
    </header>
  );
};

export default PublicHeader;
